import React from 'react';

import { Button, Dropdown, Menu, Input } from 'antd';
import { Building, ChevronDown } from '@nackle/origami-icons';

import { HIERARCHY_TYPES } from '../../services/branding';
import HierarchyStore from '../../stores/hierarchy';
import { getKey } from '../../utils/hierarchy';

import './hierarchy-button.less';

export default class HierarchyButton extends React.Component {
    state = {
        loading: false,
        items: [],
        menuVisible: false
    };

    static getDerivedStateFromProps( props, state ) {
        if ( state.hierarchyKey !== getKey( props ) ) {
            return {
                hierarchyKey: null
            };
        }
        return null;
    }

    componentDidMount() {
        this.load();
    }
    componentDidUpdate( prevProps, prevState ) {
        const { loading, hierarchyKey } = this.state;

        if ( !hierarchyKey && !loading ) {
            this.load();
        }
    }

    render() {
        const {
            hierarchyId
        } = this.props;

        const {
            loading,
            items,
            menuVisible
        } = this.state;

        const item = items.find( i => i.id === hierarchyId );

        return (
            <Dropdown
                trigger={ [ 'click' ] }
                visible={ menuVisible }
                onVisibleChange={ this.handleMenuVisibleChange }
                placement="bottomCenter"
                overlay={ (
                    <ItemMenu
                        items={ items }
                        onClick={ this.handleMenuClick }
                    />
                ) }
            >
                <Button
                    type="primary"
                    ghost={ true }
                    disabled={ loading }
                    loading={ loading }
                    icon={ item ? (
                        item.icon
                    ) : (
                        <Building />
                    ) }
                >
                    <span>
                        { item ? item.name : 'Company' }
                    </span>
                    <ChevronDown />
                </Button>
            </Dropdown>
        );
    }

    handleMenuVisibleChange = ( visible ) => {
        this.setState( {
            menuVisible: visible
        }, () => {
            if ( visible ) {
                setTimeout( () => {
                    document.getElementById( 'brandingHierarchyMenuFilterInput' ).focus();
                }, 333 );
            }
        } );
    };
    handleMenuClick = ( hierarchyId ) => {
        const { onChange } = this.props;
        if ( typeof onChange === 'function' ) {
            onChange( hierarchyId );
        }

        this.setState( { menuVisible: false } );
    };

    load = async () => {
        this.setState( {
            loading: true,
            loadingErrors: null,
            hierarchyKey: getKey( this.props )
        } );

        try {
            const hierarchyStore = new HierarchyStore( this.props );
            const { items } = await hierarchyStore.getItems();

            this.setState( {
                loading: false,
                items
            } );
        } catch ( { errors } ) {
            this.setState( {
                loading: false,
                loadingErrors: errors
            } );
        }
    };
}

class ItemMenu extends React.Component {
    state = {
        filter: '',
        items: null,
        filteredItems: []
    };

    static getDerivedStateFromProps( props, state ) {
        if ( props.items === state.items ) {
            return null;
        }

        return {
            items: props.items,
            filteredItems: state.filter ? (
                props.items.filter( item => item.name.toLowerCase().includes( state.filter.toLowerCase() ) )
            ) : (
                props.items
            )
        };
    }

    render() {
        const { filter, filteredItems } = this.state;
        const companyItems = filteredItems.filter( i => i.type === HIERARCHY_TYPES.COMPANY );
        const solutionItems = filteredItems.filter( i => i.type === HIERARCHY_TYPES.SOLUTION );
        const programItems = filteredItems.filter( i => i.type === HIERARCHY_TYPES.PROGRAM );

        return (
            <div className="branding-hierarchy-menu-container">
                <Input
                    autoFocus
                    id="brandingHierarchyMenuFilterInput"
                    className="company-select-filter"
                    placeholder="search..."
                    value={ filter }
                    onKeyUp={ this.handleFilterKeyUp }
                    onChange={ this.handleFilterChange }
                    allowClear={ true }
                    size="large"
                    autoComplete="off"
                />

                <Menu
                    onClick={ this.handleMenuItemClick }
                    onVisibleChange={ this.handleVisibleChange }
                >
                    {
                        companyItems.length > 0 && (
                            <Menu.Divider />
                        )
                    }
                    {
                        companyItems.map( item => (
                            <Menu.Item key={ item.id }>
                                { item.icon }
                                <span>{ item.name }</span>
                            </Menu.Item>
                        ) )
                    }
                    {
                        solutionItems.length > 0 && (
                            <Menu.Divider />
                        )
                    }
                    {
                        solutionItems.map( item => (
                            <Menu.Item key={ item.id }>
                                { item.icon }
                                <span>{ item.name }</span>
                            </Menu.Item>
                        ) )
                    }
                    {
                        programItems.length > 0 && (
                            <Menu.Divider />
                        )
                    }
                    {
                        programItems.map( item => (
                            <Menu.Item key={ item.id }>
                                { item.icon }
                                <span>{ item.name }</span>
                            </Menu.Item>
                        ) )
                    }
                </Menu>
            </div>
        );
    }

    handleFilterChange = ( e ) => {
        const { items } = this.props;
        const filter = e.target.value;

        this.setState( {
            filter,
            filteredItems: filter ? (
                items.filter( item => item.name.toLowerCase().includes( filter.toLowerCase() ) )
            ) : (
                items
            )
        } );
    };
    handleFilterKeyUp = ( e ) => {
        const { filter, filteredItems } = this.state;

        if ( e.keyCode === 13 ) {
            if ( filter && filteredItems.length == 1 ) {
                this.handleMenuItemClick( { key: filteredItems[ 0 ].id } );
            }
        } else if ( e.keyCode === 27 ) {
            this.handleSelectClick();
        }
    };
    handleMenuItemClick = ( e ) => {
        const { onClick, items } = this.props;

        if ( typeof onClick === 'function' ) {
            onClick( items.find( i => i.id === e.key ) );
        }
    };
}
